import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {center} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {PaletteColorsEnum} from '../../../../../../libs/shared/ui/src/styles/paletteModel';
import {ThemeContextType} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface CellDraftIconProps {
  isSelected?: boolean;
  iconName: IconName;
  color: PaletteColorsEnum;
}

/*
 * Style.
 */

interface IconStyleProps {
  $isSelected?: boolean;
  $color: PaletteColorsEnum;
}
const StyledIconDiv = styled.div<IconStyleProps>`
  grid-area: bottom-left;
  height: 100%;
  color: ${(p) => getIconColor(p)};

  ${center()};
`;

function getIconColor({$isSelected, $color, theme}: IconStyleProps & ThemeContextType) {
  if ($isSelected) {
    return theme.invertedIcon;
  }

  return theme.palette[$color].shade40;
}

/*
 * Components.
 */

export const CellDraftIcon: FC<CellDraftIconProps> = (props) => (
  <StyledIconDiv $isSelected={props.isSelected} $color={props.color}>
    <Icon name={props.iconName} />
  </StyledIconDiv>
);
